import { fromJS, Record } from 'immutable';

export const usersRecord = new Record({
  byId: fromJS({}),
  allIds: fromJS([]),
  byProjectId: fromJS({})
});

export default usersRecord();
